import { Asset } from "expo-asset";
import * as FileSystem from "expo-file-system";
import { Platform } from "react-native";

let cachedSchemaHash: string | null = null;
let loadingSchemaHash: Promise<string | null> | null = null;

const readSchemaHashFromAsset = async () => {
  try {
    const asset = Asset.fromModule(require("../schemas/schema_hash.txt"));

    if (!asset.localUri) {
      await asset.downloadAsync();
    }

    const uri = asset.localUri ?? asset.uri;

    if (!uri) {
      return null;
    }

    if (Platform.OS === "web") {
      const response = await fetch(uri);
      if (!response.ok) {
        return null;
      }

      const text = await response.text();
      return text.trim();
    }

    const content = await FileSystem.readAsStringAsync(uri);
    return content.trim();
  } catch (error) {
    console.warn("Unable to read schema hash asset", error);
    return null;
  }
};

export const getSchemaHash = async () => {
  if (cachedSchemaHash) {
    return cachedSchemaHash;
  }

  if (!loadingSchemaHash) {
    loadingSchemaHash = readSchemaHashFromAsset();
  }

  cachedSchemaHash = (await loadingSchemaHash) ?? null;
  return cachedSchemaHash;
};
